import { gql } from 'graphql-request'

export const QueryBlockCustomersTop = gql`
  fragment FragmentBlockCustomersTop on BlockCustomersTopModelRecord {
    __typename
    id
    title
    description {
      value
    }
    customerTypesFilter
    customerTypes{
      key
      value
    }
    defaultStoryHighlight {
      slug
      title
      description {
        value
      }
      logo {
        url
      }
      type: typeField {
        key 
      }
      image {
        width
        height
        url
        title
        responsiveImage {
          ...responsiveImageFragment
        }
      }
      video {
        ...QueryVideo
      }
      customerType
    }
  }
`
export const BlockCustomersTop = {
  __typename: 'BlockCustomersTop',
  fragmentName: 'FragmentBlockCustomersTop',
  fragmentQuery: QueryBlockCustomersTop,
  fragments: ['QueryVideo']
}
